var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "keep-alive",
    { attrs: { max: _vm.maxKeepAlive, include: _vm.pagesWithCache } },
    [_c("router-view", { key: _vm.routerViewKey })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }